import {
  type BoxProps,
  Column,
  Box,
  Row,
  ChakraAspectRatio,
} from "@hightouch/htui";
import { usePulseStaggerAnimation } from "./utils";

/**
 * Loader animation for funnel charts.
 * Staggered pulse effect.
 */
export const FunnelChartLoader = (props: BoxProps) => {
  const { className, scope } = usePulseStaggerAnimation();

  return (
    <Column
      ref={scope}
      align="center"
      boxSize="100%"
      maxW="700px"
      mx="auto"
      {...props}
    >
      <ChakraAspectRatio ratio={5 / 2} w="100%" maxH="100%">
        <Row w="100%" gap={8}>
          <Funnel className={className} height="90%" />
          <Funnel className={className} height="60%" />
          <Funnel className={className} height="20%" />
        </Row>
      </ChakraAspectRatio>
    </Column>
  );
};

function Funnel({ className, height }: Pick<BoxProps, "className" | "height">) {
  return (
    <Column
      align="center"
      alignSelf="end"
      pos="relative"
      flex={1}
      w="100%"
      height={height}
    >
      <Box
        className={className}
        boxSize="100%"
        bg="gray.200"
        borderRadius="2xl"
      />
      <Box
        pos="absolute"
        height={6}
        top={-3}
        w="33%"
        bg="white"
        borderRadius="md"
        borderWidth="hairline"
        borderStyle="solid"
        borderColor="base.divider"
        boxShadow="buttonShadowLight"
      />
    </Column>
  );
}
